export default __webpack_public_path__ + "static/media/gallery-wip-pommel_09.68571df7.jpg";